import { ApplicationState } from '../store';

// eslint-disable-next-line import/prefer-default-export
export const sessionFeedbackSelector = (state: ApplicationState) =>
  state.sessionFeedback;
